import { render, staticRenderFns } from "./PlpView.vue?vue&type=template&id=f58aca72&scoped=true&"
import script from "./PlpView.vue?vue&type=script&lang=js&"
export * from "./PlpView.vue?vue&type=script&lang=js&"
import style0 from "./PlpView.vue?vue&type=style&index=0&id=f58aca72&lang=scss&scoped=true&"
import style1 from "./PlpView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58aca72",
  null
  
)

export default component.exports